import Vue from 'vue';
import Toasted from 'vue-toasted';
import './index.css';

Vue.use(Toasted, {position: 'bottom-right'});